(() => {
  const name = 'addToCart';

  App.productPage = App.productPage || {};

  App.productPage[name] = (() => {
    const template = JST['add-to-cart-widget'];
    const maxSlidesAtOnce = 3;
    const impressionsMap = {
      desktop: 3,
      tablet: 2,
      mobile: 1,
    };
    let resolution = null;

    /**
     * @function disableOffersPopup
     * @description - disable the product offers popup from showing up
     * @access private
     * @param {String} isDisable - e.g. true/false
     */
    const disableOffersPopup = function (isDisable) {
      const url = `/offers/setDisablePopupOffers?isDisable=${isDisable}`;

      $.ajax({
        url,
        type: 'POST',
        error() {
          App.sendErrorToRaygun('The popup disabling did not work');
        },
      });
    };

    /**
     * @function addOfferToCart
     * @description - add an offer to the cart
     * @access private
     * @param {Object} offer - product
     */
    // eslint-disable-next-line no-unused-vars
    const addOfferToCart = function (offer) {
      const products = [];
      const params = {
        productID: String(offer.productId),
        type: offer.type,
      };
      let callback = null;

      if (offer.type === 'WMTTB') {
        window.open(`/${offer.productLink}`, '_blank');
        return false;
      }

      if (offer.type === 'LENS') {
        params.lenses = [
          '{"eye":"_right","quantity":"2"}',
          '{"eye":"_left","quantity":"2"}',
        ];
        callback = function () {
          window.open(App.global.getRedirectUrl('/cart'), '_blank');
        };
      }

      products.push(params);

      $(offer.clickBtn)
        .parents('.carousel-wrapper__product')
        .children('.carousel-wrapper__msg')
        .removeClass('hide');
      $(offer.clickBtn).remove();

      return $.ajax({
        url: '/addorder',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify({ products }),
        type: 'POST',
        success() {
          if (callback) {
            callback();
          }
        },
        error() {
          App.ui.popup(texts('addOrderError@product'), {
            className: 'dialog-window',
            alert: {
              ok: {
                text: texts('confirm@paymentPop'),
              },
            },
          });
        },

      });
    };

    /**
     * @function setEventListeners
     * @description - setting different event handlers
     * @access private
     */
    const setEventListeners = function () {
      $(document)
        .on('click', '#close-popup', () => {
          $('.popup-window__close').click();
        });

      $('#no-popup')
        .change(function onChangeNoPopupHandler() {
          if ($(this).prop('checked')) {
            disableOffersPopup('true');
          } else {
            disableOffersPopup('false');
          }
        });
    };

    /**
     * @function showOffersPopUp
     * @description - show the product offers popup
     * @access private
     * @param {Object} productOffersData - product offers
     */
    const showOffersPopUp = function (productOffersData) {
      const element = template(productOffersData);
      const offersLength = productOffersData.allOffers.length;
      const popupOptions = {
        className: 'popup-window__content_a2c',
        title: `<h1>${texts('secondaryOffersMessage@offerPopup')}</h1>`,
        titleClassName: 'popup-window__heading',
        isCssPositioned: true,
        callbacks: {
          beforeShow() {
            $('#popup-related-products')
              .parent()
              .addClass('popup-related-products-wrap')
              .prev()
              .contents()
              .wrap('<span>');
          },
        },
      };

      App.ui.popup(element, popupOptions);
      App.require({
        fragment: $(element),
        success() {
          let carousel;
          const offersWrapper = document.getElementById('product-offers-wrapper');

          if (offersLength < maxSlidesAtOnce) {
            carousel = App.ui.carousel.init(offersWrapper, offersLength);
          } else {
            carousel = App.ui.carousel.init(offersWrapper, maxSlidesAtOnce);
          }

          carousel.on('goRight', function onGoRightCarouselHandler(data) {
            const step = data.currentIndex - 1;
            if (!this.trackedProducts) {
              this.trackedProducts = [];
            }
            if (data.currentIndex <= productOffersData.allOffers.length
              && this.trackedProducts.indexOf(data.currentIndex) === -1) {
              this.trackedProducts.push(data.currentIndex);
              TrackApp.trackUpsellData(
                'productListView',
                [productOffersData.allOffers[step]],
                (data.currentIndex + (carousel.isMobile ? 1 : 2)),
              );
            }
          });

          App.common.offersComponent.init('product-offers-wrapper');
        },
      });

      App.productPage.getStockInformation('MIXED', '.carousel-wrapper__product-list');
      TrackApp.trackUpsellData(
        'productListView',
        productOffersData.allOffers.splice(0, impressionsMap[resolution]),
      );
      setEventListeners();
    };

    const getProductOffersConfig = (function getProductOffersConfig() {
      const config = {};
      config.getForProduct = {
        url(productId) {
          return `/offers/getForProduct?productId=${productId}`;
        },
        callback(data, callMethod) {
          const productType = data.mainProduct.type;
          if (!data.disableToShowPopupOffers && data.allOffers.length && data.order) {
            showOffersPopUp(data);
          } else if (productType !== 'EXTRA') {
            callMethod(null, 'showPageOffers');
          }
        },
      };
      config.showPageOffers = {
        url() {
          return '/offers/showPageOffers';
        },
        callback() {
          window.location = App.global.getRedirectUrl('/cart');
        },
      };
      config.getForAll = {
        url() {
          return '/offers/getCartOffers';
        },
        callback: config.getForProduct.callback,
      };

      return config;
    }());

    const getProductId = function () {
      const { currentProduct } = App.productPage;
      return currentProduct ? currentProduct.id : null;
    };

    /**
     * @function getProductOffers
     * @description - get product offers for a paricular product
     * @access private
     * @param {String} productId - product id
     */
    const getProductOffers = function (productId, requestType) {
      const type = requestType || 'getForProduct';
      const url = getProductOffersConfig[type].url(productId);

      $.ajax({
        url,
        type: 'GET',
        success(data) {
          const productOffersData = JSON.parse(data);
          getProductOffersConfig[type].callback(productOffersData, getProductOffers);
        },
        error() {
          App.ui.popup(texts('getOrderRowsError@product'), {
            className: 'dialog-window',
            alert: {
              ok: {
                text: texts('confirm@paymentPop'),
              },
            },
          });
        },
      });
    };

    const increasePopupCounter = function () {
      const $totalProductsCount = $('#total-counter-value');
      const $basketIcon = $('#total-counter-ico').find('.svg-basket-ico').addClass('pulse');
      $totalProductsCount.text($('#popup-related-products-list').children().length);
      $basketIcon.on(App.global.animationEndEvent, function onAnimationEndEventAddToCartHandler() {
        $(this).removeClass('pulse');
      });
    };

    const renderNewPopupProduct = function (product) {
      const popupProductTemplate = $(JST['add-to-cart-new-product'](product));
      const $wrapper = $('#popup-related-products-list');
      const $existingProduct = $wrapper.find(`[data-id="${product.productID}"]`);
      if ($existingProduct.length) {
        $existingProduct.replaceWith(popupProductTemplate);
      } else {
        $wrapper.append(popupProductTemplate);
      }
      increasePopupCounter();
      $(window).trigger('resize');
    };

    const checkOffers = function (options) {
      const checkOptions = options || {};
      let defaultMethodName = checkOptions.defaultName || 'default';
      const notEmptyBucket = typeof checkOptions.bucketCount === 'undefined' || checkOptions.bucketCount > 0;
      const vwo = window.vwosettings || {};
      const productId = getProductId();

      const defaultCheckOffers = function () {
        $.get('/offers/showPageOffers', {}, () => {
          if (!window.dataLayer.isCartPage) {
            window.location.href = App.global.getRedirectUrl('/cart');
          }
        });
      };
      const vwoCallBacks = {
        precart() {
          window.location.href = App.global.getRedirectUrl('/precart');
        },
        addtocart() {
          if (App.settings.upsellProductPage === true && productId && notEmptyBucket) {
            getProductOffers(productId);
          } else {
            window.location.href = App.global.getRedirectUrl('/cart');
          }
        },
        none() {
          window.location.href = App.global.getRedirectUrl('/cart');
        },
        stay() {
          TrackApp.pushEventToDataLayer('vwo_stay');
        },
        defaultForProductPage() {
          if (App.settings.upsellProductPage === true) {
            getProductOffers(productId);
          } else {
            window.location.href = App.global.getRedirectUrl('/cart');
          }
        },
        default: defaultCheckOffers,
      };
      let defaultMethod = vwoCallBacks.default;

      if (vwo && vwo.upsellMethod) {
        defaultMethodName = vwo.upsellMethod;
        defaultMethod = vwoCallBacks[defaultMethodName];
      }

      if (defaultMethod) {
        vwoCallBacks[defaultMethodName]();
      }
    };

    /**
     * Init
     * @public
     */
    const init = function () {
      const productId = getProductId();
      resolution = App.global.getScreenSize();
      getProductOffers(productId);
    };

    return {
      init,
      checkOffers,
      renderNewPopupProduct,
    };
  })();
})();
